import React from 'react'
import ContentLoader from 'react-content-loader'

const PurchaseHistoryLoader = ({ className }) => {
    return (
        <ContentLoader height={'72px'} width={'100%'} className={className}>
            <rect height={'72px'} width={'100%'} rx={'4px'} ry={'4px'} />
        </ContentLoader>
    )
}

export default PurchaseHistoryLoader
